<template>
  <div id="box">
    <div class="backShow"></div>
    <div class="back" v-on:click="back">
      <img src="../assets/GoBack.png" alt />
    </div>
    <div class="title">商家资质</div>
    <div class="imgBox">
      <div class="header">营业执照</div>
      <div class="imgList">
        <img
          v-for="(item,index) in licenseImage"
          :key="index"
          :style="index%2==0?'margin-right:0.2rem':''"
          :src="CShttp+item"
          :onerror="errorImg"
          alt
        />
      </div>
    </div>
    <div class="imgBox">
      <div class="header">店铺照片</div>
      <div class="imgList">
        <img
          :style="index%2==0?'margin-right:0.2rem':''"
          v-for="(item,index) in photoImage"
          :key="index"
          :src="CShttp+item"
          :onerror="errorImg"
          alt
        />
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "",
  data() {
    return {
      info: "",
      CShttp: this.$store.state.CShttp,
      licenseImage: "",
      photoImage: "",
      errorImg: 'this.src="' + require("../assets/errorImg.jpg") + '"'
    };
  },
  components: {},
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
     this.$store.commit("UserSelf", JSON.parse(localStorage.getItem("ZQUserSelf")));
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    this.info = this.$route.query.info;
    this.licenseImage = this.info.shop_license_image
      ? this.info.shop_license_image.split(",")
      : "";
    this.photoImage = this.info.shop_photo_image
      ? this.info.shop_photo_image.split(",")
      : "";
  },
  methods: {
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang='scss' scoped>
#box {
  width: 7.5rem;
  height: 100vh;
  background: white !important;
}
.title {
  font-size: 0.32rem;
  line-height: 0.9rem;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 0.3rem;
}
.back {
  position: absolute;
  top: 0.3rem;
  left: 0.2rem;
  width: 0.4rem;
  height: 0.4rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.imgBox {
  margin: 0 0.4rem 0.4rem 0.3rem;
  font-size: 0.28rem;
  border-radius: 0.2rem;
  background: #f5f5f5;
  padding: 0.3rem;
}
.imgBox > .header {
  line-height: 0.9rem;
}
.imgList {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.imgList > img {
  width: 2.95rem;
  height: 2.95rem;
  margin-bottom: 0.2rem;
}
</style>>
